<app-expandable-section
  [title]="'DEAD_LETTERS.DETAIL.SECTIONS.TREATMENT_GROUP' | translate"
  [(expanded)]="expanded"
  (expandedChange)="expandedChange.emit($event)"
  [showChangeIndicator]="showChangeIndicator">
  <div class="metadata-grid">
    @for (entry of treatmentGroupCompare | keyvalue; track entry) {
      <div class="compare-field">
        <span class="label">{{ entry.value.labelKey | translate }}</span>
        <span class="value" [class.value-changed]="entry.value.changed">
          {{ entry.value.value || ('DEAD_LETTERS.DETAIL.VALUES.NOT_AVAILABLE' | translate) }}
          @if (entry.value.changed) {
            <mat-icon
              class="change-icon"
              [matTooltip]="('DEAD_LETTERS.DETAIL.VALUES.PREVIOUS_VALUE' | translate) + ': ' + (entry.value.previousValue || ('DEAD_LETTERS.DETAIL.VALUES.NOT_AVAILABLE' | translate))">
              change_circle
            </mat-icon>
          }
        </span>
      </div>
    }
  </div>
</app-expandable-section>
